var qs = require('qs');
const nodeURL = process.env.REACT_APP_STRAPI_URL
const headers = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('accessToken')}`
})

// Helper function to handle fetch responses with rate limit detection
const handleFetchResponse = async (response) => {
  if (response.status === 429) {
    const error = new Error('Rate limit exceeded. Please wait a moment and try again.');
    error.status = 429;
    error.rateLimit = true;
    // Try to get retry-after header
    const retryAfter = response.headers.get('Retry-After');
    if (retryAfter) {
      error.retryAfter = parseInt(retryAfter, 10);
    }
    throw error;
  }

  if (!response.ok) {
    const error = new Error(`HTTP error! status: ${response.status}`);
    error.status = response.status;
    throw error;
  }

  return response.json();
}


// ********** CREATE WORK ORDER  ********** //
export const createWorkorder = async (details) => {
  const opts = {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(details),
  }

  const response = await fetch(`${nodeURL}/workorders`, opts);
  return await response.json();
}

// ********** CREATE WORK ORDER  ********** //
export const workOrderSendNotification = async (id, recipients, message, emails) => {
  const opts = {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ recipients, message, emails }),
  }

  const response = await fetch(`${nodeURL}/workorders/notify/${id}`, opts);
  const data = response.json();

  return data;
}

// ********** REPAIR WORK ORDER ROOMS ********** //
export const repairWorkorderRooms = async (id) => {
  const opts = {
    method: 'POST',
    headers: headers(),
  }

  const response = await fetch(`${nodeURL}/workorders/repair/${id}`, opts);
  const data = response.json();

  return data;
}

// ********** GET ALL WORK ORDERS  ********** //
// NOTE: This function fetches ALL non-complete workorders. Use with caution.
// Consider using fetchRecentlyUpdatedWorkorders or fetchWorkordersByStatus for better performance.
export const fetchWorkorders = async (maxLimit = 100) => {
  // Cap the limit to prevent unbounded queries (max 100 per request)
  const limit = Math.min(maxLimit, 100);
  let start = 0;
  let hasMore = true;
  let allWorkorders = [];

  while (hasMore) {
    const opts = {
      method: 'GET',
      headers: headers(),
    };

    const response = await fetch(`${nodeURL}/workorders?status_ne=complete&_limit=${limit}&_start=${start}&_exclude[]=changelogs&_exclude[]=floors&_exclude[]=rooms&_exclude[]=images&_exclude[]=documents`, opts);
    const data = await response.json();

    allWorkorders = [...allWorkorders, ...data];

    if (data.length < limit) {
      hasMore = false;
    } else {
      start += limit;
      // Safety limit: stop after fetching 1000 records total to prevent memory issues
      if (allWorkorders.length >= 1000) {
        console.warn('fetchWorkorders: Stopped at 1000 records to prevent performance issues. Consider using pagination or more specific queries.');
        hasMore = false;
      }
    }
  }

  return allWorkorders;
};

// ********** GET RECENTLY UPDATED WORK ORDERS (OPTIMIZED) ********** //
// Fetches workorders updated within the last N days using server-side filtering
// This is much more efficient than fetching all workorders and filtering client-side
export const fetchRecentlyUpdatedWorkorders = async (days = 5, limit = 50) => {
  const opts = {
    method: 'GET',
    headers: headers(),
  };

  // Calculate the date threshold for server-side filtering
  const dateThreshold = new Date();
  dateThreshold.setDate(dateThreshold.getDate() - days);
  const dateString = dateThreshold.toISOString().split('T')[0]; // YYYY-MM-DD format

  // Use server-side filtering with updatedAt_gte to only fetch recent workorders
  const queryParams = new URLSearchParams({
    status_ne: 'complete',
    updatedAt_gte: dateString,
    _limit: limit.toString(),
    _sort: 'updatedAt:DESC',
    '_exclude[]': 'changelogs',
    '_exclude[]': 'floors',
    '_exclude[]': 'rooms',
    '_exclude[]': 'images',
    '_exclude[]': 'documents'
  });

  const response = await fetch(`${nodeURL}/workorders?${queryParams.toString()}`, opts);
  const data = await response.json();

  return data;
};

// ********** GET A WORK ORDER (BY ID)  ********** //
export const fetchAWorkOrder = async (id) => {
  const opts = {
    method: 'GET',
    headers: headers(),
  }

  const response = await fetch(`${nodeURL}/workorders/${id}`, opts);
  const data = response.json();

  return data;
}

// ********** GET A WORK ORDER (BY ID)  ********** //
export const migrateWOActivityLog = async (id) => {
  const opts = {
    method: 'GET',
    headers: headers(),
  }

  const response = await fetch(`${nodeURL}/workorders/restorecl/${id}`, opts);
  console.log(response)
  const data = await response.json();
  console.log(data)

  return data.result;
}

// ********** GET ALL WORK ORDERS BY STATUS  ********** //
export const fetchWorkordersByStatus = async (status, limit = 50, searchTerm = false, start = 0) => {
  const opts = {
    method: 'GET',
    headers: headers()
  }

  let queryObj = {
    _sort: 'createdAt:DESC',
    _limit: limit,
    _start: start,
    _exclude: ['changelogs', 'floors', 'rooms', 'images', 'documents', 'assigned_to_sales', 'assigned_to_pm', 'assigned_to_leadtech'],
    _where: [{ 'status_eq': status }],
  }
  if (searchTerm) {
    queryObj._where.push({
      _or: [
        { 'title_contains': searchTerm },
        { 'client_name_contains': searchTerm }, // Use denormalized field instead of client.name
        { 'location_title_contains': searchTerm } // Use denormalized field instead of location.title
      ],
    })
  }

  const query = qs.stringify(queryObj);

  // const response = await fetch(`${nodeURL}/workorders/${status}`, opts);
  const response = await fetch(`${nodeURL}/workorders?${query}`, opts);
  const data = await handleFetchResponse(response);
  return data;
}


// ********** EXPORT ALL WORK ORDERS USING AGGREGATION  ********** //
export const exportAllWorkorders = async (startDate = null, endDate = null) => {
  // Build query string with date parameters
  const params = new URLSearchParams();
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);

  const queryString = params.toString();
  const url = `${nodeURL}/workorders/export/all${queryString ? `?${queryString}` : ''}`;

  const opts = {
    method: 'GET',
    headers: headers()
  }

  try {
    const response = await fetch(url, opts);
    const data = await response.json();

    if (data.success) {
      console.log('Exported workorders count:', data.count);
      console.log('Date range:', data.dateRange);
      return data.data;
    } else {
      throw new Error(data.message || 'Export failed');
    }
  } catch (error) {
    console.error('Export workorders error:', error);
    throw error;
  }
}

// ********** UPDATE A WORK ORDER (BY ID)  ********** //
export const updateWorkorder = async (id, details) => {
  const opts = {
    method: 'PUT',
    headers: headers(),
    body: JSON.stringify(details)
  }

  const response = await fetch(`${nodeURL}/workorders/${id}`, opts);
  const data = response.json();

  return data;
}

// ********** DELETE A WORK ORDER (BY ID) - DOES NOT ACTUALLY DELETE JUST SETS STATUS AS DELETED  ********** //
export const deleteWorkorder = async (id) => {
  const opts = {
    method: 'PUT',
    headers: headers(),
    body: JSON.stringify({ status: 'deleted' })
  }

  const response = await fetch(`${nodeURL}/workorders/${id}`, opts);
  const data = response.json();

  return data;
}

// ********** UPDATE NOTES IN WORK ORDER (BY ID)  ********** //

export const updateNotes = async (id, details) => {
  const opts = {
    method: 'PUT',
    headers: headers(),
    body: JSON.stringify(details)
  }

  const response = await fetch(`${nodeURL}/workorders/${id}`, opts);
  const data = response.json();

  return data;
}

export const fetchWorkordersById = async (workdorderIds) => {
  const opts = {
    method: "GET",
    headers: headers(),
  };
  let url = `${nodeURL}/workorders`
  const params = new URLSearchParams()
  workdorderIds.forEach((id) => {
    params.append("id_in", id)
  })
  const response = await fetch(url + "?" + params.toString(), opts).then(data => data.json());
  return response;
}

export const fetchWorkordersByUserId = async (id) => {
  const opts = {
    method: 'GET',
    headers: headers(),
  };

  let queryObj = {
    _where: [{
      _or: [
        { "assigned_to": id },
        { "assigned_to_sales": id },
        { "assigned_to_pm": id },
        { "assigned_to_leadtech": id }
      ],
    }],
  }

  const query = qs.stringify(queryObj);

  const response = await fetch(`${nodeURL}/workorders?${query}`, opts).then(data => data.json());

  return response;
}

// ********** GET WORK ORDERS OPTIMIZED FOR LIST VIEW ********** //
// Fetches workorders with role-based filtering and status filtering on the server
// This is much more efficient than fetching all workorders and filtering client-side
export const fetchWorkordersForListView = async (user, options = {}) => {
  // Return empty structure if user is not available
  if (!user || !user.id) {
    console.warn('fetchWorkordersForListView: User not available');
    return {
      scheduled: [],
      pending: [],
      drafts: [],
      today: [],
      all: []
    };
  }

  const {
    statuses = ['scheduled', 'pending', 'draft'], // Array of statuses to fetch
    limit = 50, // Limit per status (reduced for pagination)
    start = 0, // Start offset for pagination
    includeToday = true, // Whether to include today's schedule items logic
    page = 1, // Page number (1-indexed) - applies to all statuses
    pageSize = 50, // Items per page
    statusPage = {}, // Per-status page numbers: { scheduled: 1, pending: 1, etc. }
    searchTerm = null // Search term (requires 3+ characters, searches across all pages)
  } = options;

  const opts = {
    method: 'GET',
    headers: headers(),
  };

  // For admins and users without role restrictions, fetch all workorders by status
  // For technicians, sales, and PMs, use the optimized by-user endpoint
  const isRestrictedUser = user && user.role && (
    user.role.type === 'technician' ||
    user.role.type === 'lead_technician' ||
    user.role.type === 'sales' ||
    user.role.type === 'project_manager'
  );

  if (isRestrictedUser) {
    // Use the optimized endpoint that filters by user on the server
    // Note: byuser endpoint doesn't support pagination directly, so we'll paginate client-side for now
    // For better performance, we could add pagination support to the byuser endpoint
    const promises = statuses.map(status => {
      const query = qs.stringify({ status });
      return fetch(`${nodeURL}/workorders/byuser/${user.id}?${query}`, opts)
        .then(handleFetchResponse)
        .catch(error => {
          if (error.rateLimit) throw error;
          console.error(`Error fetching ${status} workorders:`, error);
          return [];
        });
    });

    const results = await Promise.all(promises);

    // Apply search filtering for restricted users (client-side since byuser doesn't support search)
    let filteredResults = results;
    if (searchTerm && searchTerm.length >= 3) {
      const searchLower = searchTerm.toLowerCase();
      filteredResults = results.map(workorders =>
        workorders.filter(wo => {
          const title = wo.title?.toLowerCase() || '';
          const clientName = wo.client?.name?.toLowerCase() || '';
          const locationTitle = wo.location?.title?.toLowerCase() || '';
          return title.includes(searchLower) ||
            clientName.includes(searchLower) ||
            locationTitle.includes(searchLower);
        })
      );
    }

    // Apply client-side pagination for restricted users (only if not searching)
    // When searching, return all results (pagination agnostic)
    const paginatedResults = searchTerm && searchTerm.length >= 3
      ? filteredResults // Return all search results
      : filteredResults.map((workorders, index) => {
        const status = statuses[index];
        const statusKey = status === 'draft' ? 'drafts' : status;
        const statusPageNum = statusPage[statusKey] || page;
        const calculatedStart = (statusPageNum - 1) * pageSize;
        const startIdx = calculatedStart;
        const endIdx = calculatedStart + pageSize;
        return workorders.slice(startIdx, endIdx);
      });

    // Combine results and organize by status
    const organized = {
      scheduled: [],
      pending: [],
      drafts: [],
      today: [],
      all: []
    };

    paginatedResults.forEach((workorders, index) => {
      const status = statuses[index];
      organized[status === 'draft' ? 'drafts' : status] = workorders;
      organized.all = [...organized.all, ...workorders];

      // Filter for today if needed
      if (includeToday) {
        const todaysDate = new Date().toISOString().split('T')[0];
        const todayItems = workorders.filter(wo => wo.isTodaysWorkOrder ||
          (wo.scheduleitems && wo.scheduleitems.some(si =>
            si.startTime && si.startTime.split('T')[0] === todaysDate
          ))
        );
        organized.today = [...organized.today, ...todayItems];
      }
    });

    return organized;
  } else {
    // For admins, fetch all workorders by status in parallel with pagination
    // When searching, fetch all results (no pagination), otherwise use pagination
    const promises = statuses.map(status => {
      const statusKey = status === 'draft' ? 'drafts' : status;

      // If searching, use reasonable limit (100 per status = 300 max total)
      // Otherwise, use pagination
      if (searchTerm && searchTerm.length >= 3) {
        return fetchWorkordersByStatus(status, 100, searchTerm, 0) // Reasonable limit for search (100 per status)
          .catch(error => {
            if (error && error.rateLimit) throw error;
            console.error(`Error fetching ${status} workorders:`, error);
            return [];
          });
      } else {
        const statusPageNum = statusPage[statusKey] || page;
        const calculatedStart = (statusPageNum - 1) * pageSize;
        return fetchWorkordersByStatus(status, pageSize, false, calculatedStart)
          .catch(error => {
            if (error && error.rateLimit) throw error;
            console.error(`Error fetching ${status} workorders:`, error);
            return [];
          });
      }
    });

    const [scheduled, pending, drafts] = await Promise.all(promises);

    const all = [...(scheduled || []), ...(pending || []), ...(drafts || [])];

    // Filter for today
    let today = [];
    if (includeToday) {
      const todaysDate = new Date().toISOString().split('T')[0];
      today = all.filter(wo => {
        if (!wo.scheduleitems) return false;
        return wo.scheduleitems.some(si =>
          si.startTime && si.startTime.split('T')[0] === todaysDate
        );
      });
    }

    return {
      scheduled: scheduled || [],
      pending: pending || [],
      drafts: drafts || [],
      today,
      all
    };
  }
}

// ********** GET WORK ORDER COUNTS BY STATUS ********** //
// Gets total count of workorders by status for pagination
// Note: This fetches all records to count them. For better performance, consider adding a count endpoint.
export const fetchWorkorderCountsByStatus = async (user, statuses = ['scheduled', 'pending', 'draft']) => {
  const opts = {
    method: 'GET',
    headers: headers(),
  };

  const isRestrictedUser = user && user.role && (
    user.role.type === 'technician' ||
    user.role.type === 'lead_technician' ||
    user.role.type === 'sales' ||
    user.role.type === 'project_manager'
  );

  if (isRestrictedUser) {
    // For restricted users, fetch all from byuser endpoint to get accurate counts
    // (byuser endpoint doesn't support count queries)
    const promises = statuses.map(async (status) => {
      const query = qs.stringify({ status });
      const response = await fetch(`${nodeURL}/workorders/byuser/${user.id}?${query}`, opts);
      const data = await response.json();
      return { status, count: Array.isArray(data) ? data.length : 0 };
    });

    const results = await Promise.all(promises);
    const counts = {};
    results.forEach(({ status, count }) => {
      counts[status === 'draft' ? 'drafts' : status] = count;
    });
    return counts;
  } else {
    // For admins, we'll use a more efficient approach:
    // Instead of fetching 1000 records just to count, we'll use a reasonable limit
    // and estimate counts based on whether we hit the limit
    // Note: This is not ideal but Strapi v3 doesn't have a count endpoint
    // For production, consider adding a custom count endpoint
    const promises = statuses.map(async (status) => {
      const queryObj = {
        _where: [{ 'status_eq': status }],
        _limit: 250, // Reasonable limit - if we get 250, there might be more
        status_ne: 'complete'
      };
      const query = qs.stringify(queryObj);
      const response = await fetch(`${nodeURL}/workorders?${query}`, opts);
      const data = await response.json();
      const count = Array.isArray(data) ? data.length : 0;
      // If we got the full limit, there are likely more records
      // Return the count but note it might be an underestimate
      return { status, count };
    });

    const results = await Promise.all(promises);
    const counts = {};
    results.forEach(({ status, count }) => {
      counts[status === 'draft' ? 'drafts' : status] = count;
    });
    return counts;
  }
}
